<template>
  <input
    ref="priceRef"
    type="text"
    id="price"
    :value="formattedPrice"
    @input="handleInput"
    @blur="handleBlur"
    @keydown="handleKeydown"
    @keypress.enter="keypressUser"
  />
</template>

<script>
export default {
  name: "PriceInput",
  data() {
    return {
      price: "",
      formattedPrice: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.priceRef) {
        this.$refs.priceRef.focus();
      }
    });
  },
  methods: {
    keypressUser() {
      this.$emit("onEnter");
    },
    formatPrice(value) {
      if (!value) return "";
      const num = String(value).replace(/\D/g, "");
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleInput(event) {
      const rawValue = event.target.value;
      this.price = rawValue.replace(/\D/g, "");
      this.formattedPrice = this.formatPrice(this.price);
      this.$emit("enterPrice", this.price);
    },
    handleBlur() {
      if (!this.price) {
        this.formattedPrice = "";
      } else {
        this.formattedPrice = this.formatPrice(this.price);
      }
    },
    handleKeydown(event) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (event.ctrlKey || event.metaKey) return;
      if (allowedKeys.indexOf(event.key) !== -1) return;

      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
};
</script>
